// 基础类型和接口定义
import {
  Conversation,
  Message,
  ConversationDetail,
  ConversationsResponse,
  MessagesResponse,
  SendMessageResponse,
  MessageContent,
  InitEvent,
  InitCompleteEvent,
  ContentBlockStartEvent,
  ContentBlockDeltaEvent,
  MessageStopEvent,
  ToolUseStartEvent,
  ToolResultEvent,
  ToolUseStopEvent
} from '../../../types/chat';

// 保存正在处理中的消息
export interface PendingMessage {
  conversationId: string;
  messageText: string;
  timestamp: string;
  abortController?: AbortController;
}

// 消息处理日志状态
// Define specific content structures for different log step types
export interface LlmTextContent { text: string; }
export interface ToolRequestContent {
  toolName: string;
  toolId?: string;
  input: Record<string, any>;
  status?: 'running' | 'complete' | 'error';
  _rawInputDisplay?: string;
}
export interface ToolResultSummaryContent {
  toolName: string;
  toolId?: string;
  status: 'success' | 'error';
  message: string;
  data?: Record<string, any>;
}
export interface ProcessCompleteContent { message?: string; }
export interface ProcessErrorContent { 
    message: string;
    toolId?: string;
}

// Updated ProcessLogStep interface
export interface ProcessLogStep {
  id: string;
  sequence: number;
  processType: 'llm_text' | 'tool_request' | 'tool_result_summary' | 'process_complete' | 'process_error';
  processData: 
    | LlmTextContent 
    | ToolRequestContent 
    | ToolResultSummaryContent
    | ProcessCompleteContent
    | ProcessErrorContent;
  timestamp: string;
  targetAssistantMessageId?: string | null;
  initiatingUserMessageId?: string | null;
}

export interface ProcessLogState {
  steps?: ProcessLogStep[];
  isLoading: boolean;
  error?: string;
}

// ID for the initial loading placeholder message
export const INITIAL_PLACEHOLDER_ID = 'temp-ai-loading';

// 导出所有从chat.ts导入的类型，以便其他文件可以从这里导入
export type {
  Conversation,
  Message,
  ConversationDetail,
  ConversationsResponse,
  MessagesResponse,
  SendMessageResponse,
  MessageContent,
  InitEvent,
  InitCompleteEvent,
  ContentBlockStartEvent,
  ContentBlockDeltaEvent,
  MessageStopEvent,
  ToolUseStartEvent,
  ToolResultEvent,
  ToolUseStopEvent
};
